import { useEffect, useRef, useState } from "react";

export function useCountdown(active: boolean, duration: number, triggerKey: unknown, onExpire: () => void): number {
  const [remainingTime, setRemainingTime] = useState(duration);

  const onExpireRef = useRef(onExpire);

  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    if (!active) {
      return;
    }

    if (duration <= 0) {
      const t = window.setTimeout(() => {
        setRemainingTime(0);
        onExpireRef.current();
      }, 0);

      return () => window.clearTimeout(t);
    }

    // 타이머 초기화
    let elapsedTime = 0;
    let previousTimestamp: number | null = null;
    let rafId: number;
    let expired = false;

    function loop(timestamp: number) {
      if (previousTimestamp === null) {
        setRemainingTime(duration);
        previousTimestamp = timestamp;
        rafId = requestAnimationFrame(loop);

        return;
      }

      const deltaTime = (timestamp - previousTimestamp) / 1000;
      previousTimestamp = timestamp;
      elapsedTime += deltaTime;

      const remaining = Math.max(0, duration - elapsedTime);

      if (remaining <= 0 && !expired) {
        expired = true;
        setRemainingTime(0);
        onExpireRef.current();

        return;
      }

      setRemainingTime(remaining);
      rafId = requestAnimationFrame(loop);
    }

    rafId = requestAnimationFrame(loop);

    return () => cancelAnimationFrame(rafId);
    // triggerKey(currentIndex) 변경 시 타이머 리셋, duration 변경 시에도 리셋
  }, [active, duration, triggerKey]);

  return remainingTime;
}
